export * from './metricCardPropsFromDataPoints';
